import styles from '../styles/components/subLimitModal.module.css';
import { ReactComponent as StarIcon } from "../assets/star.svg";
import Modal from './Modal';
import moment from 'moment';
import { StoreContext } from '..';
import { useContext } from 'react';
import Spinner from './Spinner';
import { Product } from '../models/product';
import { observer } from 'mobx-react-lite';
import WaitPaidInvoice from './WaitPaidInvoice';


interface ComponentProps {
    cancel: Function;
    header: string;
};


function SubLimitModal({cancel, header}: ComponentProps) {
    const {appStore} = useContext(StoreContext);
    
    const product = appStore.products.find(product => product.product_type === "subscriptions");
    return <>
        {
            appStore.checkInvoiceId && <WaitPaidInvoice 
            invoiceId={appStore.checkInvoiceId} 
            cancel={(success: boolean | null = null) => {
                appStore.checkInvoiceId = null; 
                if (success === true) {
                    cancel();
                }
            }}/>
        }
        <Modal cancel={cancel}>
            <h1>{header}</h1>
            <span className={styles.description}>Вы можете подписаться максимум на <span>15 каналов</span> в течение 24 часов</span>
            <div className={styles.balance_container}>
                <span className={styles.balance} style={{color: appStore.user.limit <= 0 ? "var(--tg-theme-destructive-text-color)" : "var(--tg-theme-accent-text-color)"}}>Осталось {appStore.user.limit} подписок {appStore.user.next_recovery && <span className={styles.next_recovery}>(+1 в {moment.unix(appStore.user.next_recovery).format("HH:mm")})</span>}</span>
                {appStore.user.next_recovery && <span className={styles.next_recovery}></span>}
            </div>
            {appStore.user.limit < 15 && <div className={styles.pay}>
                <span className={styles.pay_header}>Восстановить</span>
                <div className={styles.pay_buttons}>
                    <button className={styles.pay_button} disabled={appStore.processInvoice.endsWith("robokassa")} onClick={() => appStore.createInvoice((product as Product).id, "robokassa")}>
                        {appStore.processInvoice.endsWith("robokassa") ? <Spinner/> : <>{product?.price_rubs} руб<span>{product?.old_price} руб</span></>}
                    </button>
                    <button className={styles.star_pay_button} disabled={appStore.processInvoice.endsWith("telegram")} onClick={() => appStore.createInvoice((product as Product).id, "telegram")}>
                        {appStore.processInvoice.endsWith("telegram") ? <Spinner/> : <><StarIcon/>{product?.price_stars}</>}
                    </button>
                </div>
                <div className={styles.cancel}>
                    <span onClick={() => cancel()}>Нет, спасибо</span>
                </div>
            </div>}
            {appStore.user.limit >= 15 && <button type="submit" onClick={() => cancel()} style={{marginTop: 0}}>Понятно</button>}
        </Modal>
    </>;
};

export default observer(SubLimitModal);